import { StyleSheet } from 'aphrodite';
import constants from '../../../constants/styles';
let {
  ACCORDION_PARENT_LABEL_COLOR,
  ACCORDION_PARENT_VALUE_COLOR,
  ACCORDION_PARENT_BG_COLOR,
  ACCORDION_PARENT_HOVER_BG_COLOR,
  ACCORDION_BORDER_COLOR
} = constants;

let styles = {
  site: {
    display: 'flex',
    backgroundColor: ACCORDION_PARENT_BG_COLOR,
    padding: '20px 30px 20px 20px',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    ':hover': {
      backgroundColor: ACCORDION_PARENT_HOVER_BG_COLOR
    },
    ':last-child': {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10
    }
  },
  openSite: {
    borderBottom: `2px solid ${ACCORDION_BORDER_COLOR}`
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1.1em',
    color: ACCORDION_PARENT_VALUE_COLOR,
    paddingLeft: 30,
    paddingRight: 10,
    width: 150
  },
  value: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  label: {
    fontSize: '0.7em',
    fontWeight: 800,
    textTransform: 'uppercase',
    color: ACCORDION_PARENT_LABEL_COLOR,
    marginBottom: 5
  },
  icon: {
    cursor: 'pointer',
    fontWeight: 'bold',
    margin: 'auto 0'
  },
  iconHidden: {
    visibility: 'hidden'
  },
  options: {
    margin: 'auto 0 auto auto'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/accordionsite/AccordionSite.styles.js